import React, {useEffect} from 'react'
import Carousel from 'nuka-carousel'
import images from '../assets/img'
import { formatTime } from './utils'
import { cookImage, dishImage } from '../api'

const defautSettings = {
  autoplay: true,
  withoutControls: true,
  wrapAround: true,
  disableKeyboardControls: true,
}

export default ({ time, cookteam, dishes, ip }) => {
  const { dateValue, timeValue } = formatTime(time)
  const slider1 = {
    ...defautSettings,
    initialSlideHeight: 450,
  }
  const slider2 = {
    ...defautSettings,
    initialSlideHeight: 250,
  }

  if (cookteam.length < 2) slider1.wrapAround = false
  if (dishes.length < 2) slider2.wrapAround = false

  function unique(arr) {
    let result = [];
  
    for (let str of arr) {
      if (!result.includes(str)) {
        result.push(str);
      }
    }
  
    return result;
  }

  useEffect(() => {
  ip && unique(ip);
  }, [ip])
  
  return (
    <aside>
      <div className="slider-container ">
        <Carousel {...slider1}>
          {!cookteam.length && <img src={images.senya} alt="sliderimage" />}
          {cookteam.map(a => {
            if (a) {
              return (
                <img key={a.id} src={cookImage(a.id)} alt={a.name} />
              )
            }
          })}
        </Carousel>
      </div>
      <div className="slider-container">
        <Carousel {...slider2}>
          {!dishes.length && <img src={images.losos} alt="sliderimage" />}
          {dishes.map(a => (
            <img key={a} src={dishImage(a)} alt="sliderimage" />
          ))}
        </Carousel>
      </div>
      <span className="slider-container local-time">{dateValue}</span>
      <span className="slider-container local-time">{timeValue}</span>
      <span className="ip">{unique(ip).map((el, index) => index > 0 ? ` ,${el}` : `${el}`)}</span>
    </aside>
  )
}
